import React, {  useEffect, useCallback, useState} from 'react';  
import { useTranslation } from "react-i18next" 
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'; 
import Box from '@mui/material/Box'; 
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import Textarea from '@mui/joy/Textarea'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction, warningErrorAction } from 'actions/ErrorActions';
import { helpHttp } from 'service/HelpHttp';
import { setLoading } from 'reducers/loadingSlice';
import { ENDPOINT} from "constants/variables";
import PropTypes from 'prop-types';
 
const initialState = {
  "id":"",
  "defaultStore_id":0, 
  "tradename": "",
  "useraccount_id":0,
  "username": "", 
  "createdate": null,
  "emailto":"gestrescan@gmail.com",
  "subjectEmail":"", 
  "contentEmail":"",
  "resolution":"",
  "slatype_id":0,
  "slatype_namees": "",
  "slatype_nameen": "",
  "incidenttype_id":1, 
  "incidenttype_namees": "",
  "incidenttype_nameen": "",
  "resolution_id":0, 
  "resolution_namees": "",
  "resolution_nameen": "",
  "formdi_id":0, 
  "ownformdi_id": "",
  "numberDI_sheet": "",
  "purchase_id": "",
  "ownpurchase_id": "",
  "isfinished": false,
  "hasbeenread": false,
  "updatedFiles":[]
};

const IncidentEmailEdit = ({ openEditRow,setOpenEditRow,rowEdit}) => {
  const {t,i18n} = useTranslation(['listDataGeneralSettings']); 
  const token = useSelector((state) => state.loginUser.token); 
  const [formEditRow, setFormEditRow] = useState(initialState);
  const [errorsRow, setErrorsRow] = useState({}); 
  const [files, setFiles] = useState([]);   
  const [previewFile, setPreviewFile] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate(); 

  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && openEditRow) {
        setFormEditRow(initialState);
         setFormEditRow(formEditRow => ({
          ...formEditRow,
          updatedFiles: [],
        }));
        setErrorsRow({});  
        setFiles([]); 
        setPreviewFile(null);
        setOpenEditRow(false);
      }
    },
    [ 
      setPreviewFile,
      setFiles,
      setFormEditRow,
      setErrorsRow, 
      setOpenEditRow,  
      openEditRow
    ]
  );

  const closeModalSentEmailEdit = () => {
    setFormEditRow(initialState);
      setFormEditRow(formEditRow => ({
      ...formEditRow,
      updatedFiles: [],
    }));
    setErrorsRow({});  
    setPreviewFile(null);
    setFiles([]);
    setOpenEditRow(false); 
    navigate("/incidentemail");
  }; 

  const toggleDrawerEmail = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown' ) {
      closeModalSentEmailEdit();
      return;
    }
  }; 

  const handleChangeHasBeenEnded = (e) => {
    setFormEditRow(formEditRow => ({
      ...formEditRow,
      isfinished: !formEditRow.isfinished
    }));
  };
 
  const validateRows = () => {
    let errorsRow = {}; 
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (regexInvalidCharacters.test(formEditRow.subjectEmail)) {
      errorsRow.subjectEmail = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formEditRow.resolution)) {
      errorsRow.resolution = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formEditRow.resolution)) {
      errorsRow.resolution = 'Text_TextNoValid';
    }  
    if (formEditRow.contentEmail===undefined || formEditRow.contentEmail===null || formEditRow.contentEmail===""){
      errorsRow.contentEmail = 'Text_SENDEMAIL_ContentEmail_Required';
    }
    
    return errorsRow;
  };

  const handleConfirmFetchSendInicidents = (dataToSend) => {
    const fetchData = async () => { 
      closeModalSentEmailEdit(); 
      try {
        const getData = await helpHttp().put(ENDPOINT, `incidentemail/updatesentincident`, token, dataToSend);
        if (getData.status === "OK") {
          dispatch(setLoading(false));
          dispatch(successErrorAction(t('Text_SaveData')));
        } else {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.cause)));
        } 
      } catch (error) { 
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }   
      return () => {  };
    }; 
    fetchData();  
  };

  const handleSubmitRow = async () => {
      const errors = validateRows();
      setErrorsRow(errors); 
      if (
        Object.keys(errors).length === 0 &&
        formEditRow.id &&
        formEditRow.contentEmail !== ''
      ) { 
        dispatch(setLoading(true));
        handleConfirmFetchSendInicidents(formEditRow);
      } else {
        if (errors.subjectEmail) {
          dispatch(warningErrorAction(t(errors.subjectEmail)));
        } else if (errors.contentEmail) {
          dispatch(warningErrorAction(t(errors.contentEmail)));
        } else if (errors.resolution) {
          dispatch(warningErrorAction(t(errors.resolution)));
        } else {
          dispatch(warningErrorAction(t('Text_IncorrectData')));
        }
      } 
    };
      
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true;
    
    const fetchData = async () => { 
    
      try {
        const getData = await  helpHttp().get2(ENDPOINT,`incidentemail/getsentincidentbyid/`,token,rowEdit.id);
        if (getData.err) {
          setFormEditRow(initialState);
          setFormEditRow(formEditRow => ({
            ...formEditRow,
            updatedFiles: [],
          }));
          dispatch(setLoading(false)); 
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setFormEditRow(getData); 
          if (getData.updatedFiles.length>0){
            const existArrayFileToUpload=[];
            getData.updatedFiles.map((existFileToUpload)=>{
              const imageDataUrl = "data:"+existFileToUpload.type+";base64,"+existFileToUpload.datafile
              let result = new File([imageDataUrl.arrayBuffer], existFileToUpload.filename, { type: existFileToUpload.type, lastModified:existFileToUpload.createdate })
              return(
                (existFileToUpload.datafile!==undefined && existFileToUpload.datafile!==null && existFileToUpload.datafile!=="" )&& existArrayFileToUpload.push(
                  {
                    "data":imageDataUrl,
                    "file":result
                  }
                ))
            })
            setFiles(existArrayFileToUpload);
          }else{
            setFiles([]);
          }
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    }; 

    if (openEditRow ){
      if (rowEdit && rowEdit.id!=="" && rowEdit.id!=="0" && rowEdit.id!==0){
        if(formEditRow.id===undefined || formEditRow.id==="" || formEditRow.id==="0" || formEditRow.id===0){
          //dispatch(setLoading(true)); 
          fetchData();
        }
      }else{ 
        dispatch(setLoading(false)); 
        setFormEditRow(initialState);
         setFormEditRow(formEditRow => ({
          ...formEditRow,
          updatedFiles: [],
        }));
      } 
    }
    return () => { isMounted = false };
  }, [dispatch,t,token, openEditRow,rowEdit,formEditRow.id]);   
  return (
    <div> 
      {openEditRow && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerEmail(false)}
            onOpen={toggleDrawerEmail(true)}
          >
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '1050px' }}>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                    <i className="fas fa-solid fa-inbox text-warning"></i> {t('Text_SENDINCIDENT_Email')}
                  </h1>
                  <div>
                    <div>
                      <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={handleSubmitRow} >
                        {t('Button_Update')}
                      </button>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalSentEmailEdit} >
                        {t('Button_Back')}
                      </button>
                    </div> 
                  </div> 
                </div>    
                <h1 className="h1NewStyle mb-2">{formEditRow.emailto}</h1>
                <div className="email-card-form">
                  <div className="form-group">
                    <div className="row p-4"> 
                      <label className="text-primary">{t('Text_SENDINCIDENT_SUBJECT').toUpperCase()}&nbsp;:</label>
                      &nbsp;&nbsp;&nbsp;&nbsp; 
                      <TextField
                        id="subjectEmail" 
                        name="subjectEmail"
                        value={formEditRow.subjectEmail}
                        inputProps={{ style: { width: i18n.language === "es" ? 894 : 888, fontSize: '18px' }, maxLength: 100}}
                        InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                        label={errorsRow.subjectEmail? t(errorsRow.subjectEmail):t('Text_SENDINCIDENT_SUBJECT')}
                        placeholder={t('Text_SENDINCIDENT_SUBJECT')}
                        variant="standard"
                        disabled>
                      </TextField>
                    </div>
                    <div className="row p-4"> 
                      <label className="text-primary">{t('Text_SENDEMAIL_InicidentType').toUpperCase()}&nbsp;:</label>
                      &nbsp;&nbsp;&nbsp;&nbsp; 
                      <TextField
                        id="incidenttype_namees" 
                        name="incidenttype_namees"
                        value={i18n.language==='es'?formEditRow.incidenttype_namees:formEditRow.incidenttype_nameen}
                        inputProps={{ style: { width: i18n.language === "es" ? 711 : 739, fontSize: '18px' }, maxLength: 100}}
                        placeholder={t('Text_SENDEMAIL_InicidentType')}
                        variant="standard"
                        disabled>
                      </TextField>
                    </div>
                    <div className="row p-4"> 
                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SENDEMAIL_Content').toUpperCase()}&nbsp;:</label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <Textarea
                        id="contentEmail"
                        name="contentEmail"
                        value={formEditRow.contentEmail}
                        label={errorsRow.contentEmail?t(errorsRow.contentEmail):t('PlaceHolder_SENDEMAIL_Content')}
                        placeholder={t('PlaceHolder_SENDEMAIL_Content')}
                        sx={{ width: i18n.language === "es" ? 852 : 873, fontSize: '18px' }}
                        variant="standard"
                        minRows={20}
                        maxRows={20}
                        disabled
                      />
                    </div> 
                    <div className="row p-4"> 
                      <Checkbox
                        id="isfinished" 
                        name="isfinished"
                        checked={formEditRow.isfinished}
                        onChange={handleChangeHasBeenEnded}
                        variant="standard"
                        sx={{
                          '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                        }}
                      />
                      &nbsp;&nbsp;    
                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SENDINCIDENT_END')}</label>  
                    </div>    
                    {files.length > 0 && (
                      <div className="preview-thumbnails-wrapper">
                        <div className="preview-thumbnails">
                          {files.map((fileObj, index) => {
                            const file = fileObj.file || {};
                            const type = file.type || "";
                            const name = file.name || `file-${index}`;

                            const isImage = type.startsWith("image/");
                            const isAudio = type.startsWith("audio/");
                            const isPdf   = type === "application/pdf";

                            return (
                              <div key={index} className="thumbnail-container">
                                {/* Imagen */}
                                {isImage && (
                                  <img
                                    src={fileObj.data}
                                    alt={name}
                                    className="thumbnail-image"
                                  />
                                )} 
                                {/* Audio */}
                                {isAudio && (
                                  <div className="audio-thumbnail">
                                    <audio
                                      controls
                                      src={fileObj.data}
                                      className="audio-player"
                                    /> 
                                    <div className="audio-name" style={{ marginTop: "4px", fontSize: "12px", textAlign: "center" }}>
                                      {name}
                                    </div>
                                  </div>
                                )}


                                {/* PDF */}
                                {isPdf && (
                                   <img
                                    src={fileObj.data}
                                    alt={name}
                                    className="thumbnail-image"
                                  />
                                )}

                                {/* Otros tipos */}
                                {!isImage && !isAudio && !isPdf && (
                                  <div className="file-thumbnail">
                                    <span role="img" aria-label="file">📦</span>&nbsp;
                                    <span className="file-name">{name}</span>
                                  </div>
                                )}

                                {/* Botón para abrir el modal de preview */}
                                <button
                                  type="button"
                                  onClick={() => setPreviewFile(fileObj)}
                                  className="thumbnail-zoom-btn"
                                  title={t('Text_Zoom')}
                                >
                                  🔍
                                </button>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )} 
                  </div>  
                </div> 
              </Box>  
            </Container>
          </SwipeableDrawer>
          {previewFile && (
            <div className="preview-modal-scope">
              <div className="preview-modal-overlay">
                <div className="preview-modal-content">
                  <button
                    type="button"
                    onClick={() => setPreviewFile(null)}
                    className="preview-close-button"
                  >
                    ×
                  </button> 
                  {(() => {
                    const file = previewFile.file || {};
                    const type = file.type || "";
                    const name = file.name; 
                    if (type.startsWith("image/")) {
                      return (
                        <img
                          src={previewFile.data}
                          alt={name}
                          className="preview-image"
                        />
                      );
                    } 
                    if (type.startsWith("audio/")) {
                      return (
                        <div className="preview-audio-wrapper">
                          <p className="file-name">{name}</p>
                          <audio controls autoPlay src={previewFile.data} />
                        </div>
                      );
                    } 
                    if (type === "application/pdf") {
                      return (
                        <iframe
                          src={previewFile.data}
                          title={name}
                          className="preview-pdf"
                        />
                      );
                    } 
                    return (
                      <div className="preview-file-generic-card">
                        <div className="preview-file-generic-icon">📄</div> 
                        <p className="preview-file-generic-name">{name}</p> 
                        <a
                          href={previewFile.data}
                          download={name}
                          className="preview-file-generic-download-btn"
                        >
                          {t('Button_Download')}
                        </a>
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>
          )}

           
        </div>
      } 
    </div>
  )
}

IncidentEmailEdit.propTypes = {
  openEditRow: PropTypes.bool.isRequired,
  setOpenEditRow: PropTypes.func.isRequired
};
  
export default IncidentEmailEdit;